module.exports = __webpack_public_path__ + "img/애고미_이모티콘-13.8ef2cc4.png";